// =====================================================================
// WeddingOS – Spotify Service (Client)
// =====================================================================
// Nur noch Song-Suche über die Edge Function `spotify-search`
// (Client-Credentials, kein Brautpaar-Login). Das Schreiben in Playlists
// läuft serverseitig über das zentrale App-Konto (Edge Function
// `spotify-playlist`), nicht mehr über den Browser.
// =====================================================================

/** Live-Suche im Spotify-Katalog via Edge Function (kein User-Token nötig). */
export async function searchTracks(query, { limit = 12, market = "DE" } = {}) {
  const q = query?.trim();
  if (!q || q.length < 2) return [];          // Min. 2 Zeichen – senkt Such-Volumen
  const { supabase } = await import("./supabase");
  // Ein Retry bei transientem Fehler/Rate-Limit (429), damit der Gast nicht
  // fälschlich "keine Treffer" sieht, wenn gerade viele gleichzeitig suchen.
  for (let attempt = 0; attempt < 2; attempt++) {
    const { data, error } = await supabase.functions.invoke("spotify-search", {
      body: { query: q, limit, market },
    });
    if (!error && data?.tracks) return data.tracks;
    if (attempt === 0) await new Promise((r) => setTimeout(r, 600 + Math.random() * 400));
  }
  return [];
}
